import { render } from "./EducationProjects.vue?vue&type=template&id=5af5054c&scoped=true"
import script from "./EducationProjects.vue?vue&type=script&lang=js"
export * from "./EducationProjects.vue?vue&type=script&lang=js"

import "./EducationProjects.vue?vue&type=style&index=0&id=5af5054c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af5054c"]])

export default __exports__